import './App.css';
import Banner from './Components/Banner';
import CodePlayground from './CodePlayground';
import CheckoutForm from './Components/CheckoutForm';
import Login from './Components/Login';

import Loading from './Loading';

import Home from './pages/Home';
import Content from './pages/Content';
import Purchase from './pages/Purchase';

import { useState, createContext, useEffect } from 'react'
import { baseURL } from './Config/settings';

import { Routes, Route } from 'react-router-dom';
import CodeEditor from './Components/CodeEditor';
import FAQ from './pages/FAQ';

import { ToastContainer} from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getAuth, onAuthStateChanged } from "firebase/auth";


const userContext = createContext(null)


function App() {
  const [user, setUser] = useState(null)
  const [windowData, setWindowData] = useState(window)

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user)
        if(user !== null && user.tier === undefined) {
      fetch(`${baseURL}/auth/`, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: user.email
    })
  })
  .then(res => res.json())
  .then(data => setUser({...user, ...data}))
    }
      } 
      else {
        setUser(null)
      }
    });
    
  }, [])

  useEffect(() => {
    // if(windowData.innerWidth < 1200) {
    //       toast.warn('For Optimal Experience Please shift to a Desktop', {
    //       position: "top-right",
    //       autoClose: false,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: false,
    //       draggable: true,
    //       progress: undefined,
    //     });
        // alert('For Optimal Experience Please shift to a Desktop');
    // }
  }, [])


  return (
    <div style={{height: "100%"}}>
      <ToastContainer />
      <userContext.Provider value={{user: user, setUser: setUser}}>
        <Routes>
          <Route path="/" element={<Home></Home>}></Route>
          <Route path="/content" element={<Content></Content>}></Route>
          <Route path="/purchase" element={<Purchase></Purchase>}></Route>
          <Route path="/auth" element={<Login></Login>}></Route>
          <Route path="/content/:id" element={<CodeEditor></CodeEditor>}></Route>
          {/* <Route path="/faq" element={<FAQ></FAQ>}></Route> */}
          <Route path="*" element={<h1 style={{color: "black"}}>The page you are looking for doesn't exist. 404</h1>}></Route>
        </Routes>
      </userContext.Provider>
    </div>
  );
}

export default App;
export { userContext }
